<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-panel header="{{ 'PRODUCTOFRECUENCIA.LBL_FRECUENCIAS' | translate}}">
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioFrecuencia" name="nomFormularioFrecuencia">
      <div class="grid form-group">
        <div class="col-8 md:col-8 lg:col-8">
          <div class="div-form">
            <label>* {{ 'PRODUCTOFRECUENCIA.LBL_FRECUENCIA' | translate }}</label>
            <p-multiSelect id="idDestionos" name="nomDestinos" [options]="lisFrecuencias" filter="filter"
                           defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                           selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idFrecuencias"
                           emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           optionValue="value"
                           optionLabel="label"
            ></p-multiSelect>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idFrecuencias.invalid">
              {{ 'PRODUCTOFRECUENCIA.LBL_FRECUENCIA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-6 md:col-6 lg:col-6">
          <div class="div-form">
            <p-checkbox binary="true" label="* {{ 'PRODUCTOFRECUENCIA.LBL_INDICADORANALIZAMOS' | translate }}"
                        formControlName="indicadorAnalizamos"
            ></p-checkbox>
          </div>
        </div>
        <div class="col-6 md:col-6 lg:col-6">
          <div class="div-form">
            <p-checkbox binary="true" label="* {{ 'PRODUCTOFRECUENCIA.LBL_INDICADORCRDITODIGITAL' | translate }}"
                        formControlName="indicadorDigital"
            ></p-checkbox>
          </div>
        </div>
        <div class="col-8 md:col-8 lg:col-8 text-center" *ngIf="submitted && !f.indicadorDigital.value && !f.indicadorAnalizamos.value">
          <div class="div-form">
            <div class="p-message p-messages-error p-corner-all">
              {{ 'PRODUCTOFRECUENCIA.LBL_ERROR' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-12 lg:col-12" style="display: flex; justify-content: center;">
          <div *ngIf="!guardando">
            <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                    type="submit"
                    pButton></button>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </div>
        </div>
      </div>
    </form>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="guardando"
                 [value]="lisProductosFrecuencias" selectionMode="single" dataKey="idProductoFrecuencia"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.id}}</td>
              <td>{{row.nombreFrecuenciaProducto}}</td>
              <td class="text-center">
                <p-checkbox binary="true" [(ngModel)]="row.indicadorAnalizamos" (onChange)="actualizarIndicador(row, 'A')"
                ></p-checkbox>
              </td>
              <td class="text-center">
                <p-checkbox binary="true" [(ngModel)]="row.indicadorDigital" (onChange)="actualizarIndicador(row, 'D')"
                ></p-checkbox>
              </td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-plus" data-toggle="tooltip"
                          title="{{'BTN_AGREGAR' | translate}}" pButton
                          (click)="abrirModalFrecuenciaCuotas(row)"></button>
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_INHABILITAR' | translate}}" pButton
                          (click)="inhabilitar(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-panel>
</div>


<p-confirmDialog #cd key="frecuencias">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

<!-- MODAL FRECUENCIAS-CUOTAS -->
<p-dialog header="{{'PRODUCTOFRECUENCIA.LBL_CUOTAS' | translate}}"
          *ngIf="showModalFrecuenciasCuotas"
          #dialog
          [(visible)]="showModalFrecuenciasCuotas" modal="true"
          [contentStyle]="{ width: '800px' }"
          appendTo="body"
          [draggable]="false"
          [resizable]="false"

          >
          <app-frecuencias-cuotas
          [productoFrecuencia]="proFrecuencia"
          [esDetalle]="false"
          (dismiss)="cerrarModalFrecuenciaCuotas()"
          (centrar)="centrarDialog()"
          ></app-frecuencias-cuotas>
</p-dialog>
